
// SCRIPTS

//import { SecureHomePage } from './home/home.page'; export { SecureHomePage };
import { SitesPage } from './ctms/sites/sites.page'; export { SitesPage };
import { ActionItemsPage } from './ctms/action-items/action-items.page'; export { ActionItemsPage };
import { ContactsPage } from './ctms/contacts/contacts.page'; export { ContactsPage };
import { CommunicationsPage } from './ctms/communications/communications.page'; export { CommunicationsPage };
import { DeliverablesPage } from './ctms/deliverables/deliverables.page'; export { DeliverablesPage };
import { MilestonesPage } from './ctms/milestones/milestones.page'; export { MilestonesPage };
import { StudiesPage } from './ctms/studies/studies.page'; export { StudiesPage };
import { CTMSStudyDetailsPage } from './ctms/studies/scripts/study-details.page'; export { CTMSStudyDetailsPage };
import { SettingsPage } from './ctms/settings/settings.page'; export { SettingsPage };
import { EnrollmentPage } from './reporting/enrollment/scripts/enrollment.page'; export { EnrollmentPage };
import { LdnPage } from './public-comment/ldn.page'; export { LdnPage };
import { TrialCabPage } from './collaboration/trial-cab.page'; export { TrialCabPage };

// STYLES
import './home/home.scss';
import './site-interests/site-interest.scss';
import './public-comment/ldn.scss';
import './public-comment/sgb.scss';
import './reporting/enrollment/Enrollment.scss';
import './public-comment/glp.scss';
import './collaboration/trial-cab.scss';